module.exports = __webpack_public_path__ + "static/emma-simpson-153970-unsplash-7a593fd16ec1a25a84b198543e29b999.jpg";